/** Agreement stamps describe the displayed terms, not applicant answers.
 * Persisted copies must never select which terms a signature accepts. */
const stampFields = ['agreement_version_id', 'agreement_content_hash'] as const;

export function withoutAgreementStamps(values: Record<string, unknown> | null | undefined): Record<string, unknown> {
  const answers = { ...(values ?? {}) };
  for (const field of stampFields) delete answers[field];
  return answers;
}

/** Bind to the initial rendered view, never a newer version fetched at submit. */
export function bindAgreementView(
  values: Record<string, unknown>,
  rendered: Record<string, unknown> | undefined,
): Record<string, unknown> {
  const result = withoutAgreementStamps(values);
  for (const field of stampFields) {
    if (rendered && Object.prototype.hasOwnProperty.call(rendered, field)) result[field] = rendered[field];
  }
  return result;
}
